/* global ym */

const DEFAULT_METRIKA_ID = '110028817'

export const METRIKA_ID = process.env.VUE_APP_YANDEX_METRIKA_ID || DEFAULT_METRIKA_ID

const TAG_URL = `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`

export function initYandexMetrika () {
  window.dataLayer = window.dataLayer || []

  ;(function (m, e, t, r, i) {
    m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) }
    m[i].l = 1 * new Date()
    for (let j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) return
    }
    const k = e.createElement(t)
    const a = e.getElementsByTagName(t)[0]
    k.async = 1
    k.src = r
    a.parentNode.insertBefore(k, a)
  })(window, document, 'script', TAG_URL, 'ym')

  ym(METRIKA_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true
  })
}

export function trackPageView (path) {
  if (typeof window.ym !== 'function') return
  ym(METRIKA_ID, 'hit', path, { title: document.title })
}

export function setupRouterTracking (router) {
  router.afterEach((to, from) => {
    if (from.name === undefined) return
    trackPageView(to.fullPath)
  })
}
